export const choreManageTranslateEn = {
    CHORE_MANAGE_VIEW:{
        ADD:{
            TITLE: "Adding new chore for",
            BUTTON: "Save & assign",
            TOAST:{
                SUMMARY: "Chore assigned to",
                DETAIL: "This chore has been assigned to"
            }
        },
        LABEL_CHORE_TITLE: "Type the chore’s name...",
        LABEL_DESCRIPTION: "Description (optional)",
        LABEL_REWARD: "Reward amount",
        LABEL_DEADLINE: "Deadline",
        PLACE_HOLDER_DEADLINE: "Select a date & time"
    }
}